import { Subscription } from 'rxjs';

export const unsubscribe = (sub$?: Subscription): void => {
  if (sub$ && !sub$.closed) {
    sub$.unsubscribe();
  }
};
